/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { TextInputType } from "../../../../data/formControlTypes";
import { Button } from "react-bootstrap";
import "./FileUpload.scss";
import Image from "../../../image/Image";
import { AppIcons } from "../../../../data/appIcons";
import SwalAlert from "../../../../services/swalService/SwalService";

const FileUpload = ({
  type = TextInputType.FILE,
  name = "",
  placeholder = `Please Enter ${name}`,
  filename,
  onChange,
  onClear,
  onBlur,
  onActionClick,
  cssClass = "input-field",
  isDisable,
  isButtonVisible,
  isDownloadButton,
  acceptedFiles,
  handleViewImage,
  viewImage,
  maxFileSizeInKB = 5000,
  buttonText
}) => {
  const [fileValue, setFileValue] = useState(null);
  const fileRef = useRef();
  const { error } = SwalAlert()

  const handleInputChange = (e) => {
    const { value } = e.target;
    const extension = value?.split(".")[value?.split(".").length - 1];
    const isAccepted = acceptedFiles
      ?.split(',')
      ?.map(ext => ext.trim().replace('.', '').toLowerCase())
      ?.includes(extension.toLowerCase()) || false;

    const fileSize = e?.target?.files[0]?.size / 1024
    const extensionInvalid = !isAccepted;
    const isTooLarge = fileSize > maxFileSizeInKB;

    if (isTooLarge || extensionInvalid) {
      const errorMessage = isTooLarge
        ? "File size is too large"
        : `Invalid file type. Accepted types are: ${acceptedFiles}`;

      error(errorMessage, "Error");

      fileRef.current.value = null;
      if (fileValue !== null) 
        // setFileValue(null);
      filename = null;
    } else {
      onChange(e);
    }

  };

  const handleClearClick = () => {
    if (onClear) {
      fileRef.current.value = null;
      setFileValue(null);
      filename = null;
      onClear();
    }
  };


  const handleViewImageClick = () => {
    handleViewImage()
  }

  const handleActionClick = () => {
    onActionClick();
  };

  useEffect(() => {
    if (filename && typeof filename === "object") {
      setFileValue(filename.name || filename.fileName);
    } else if (filename) {
      setFileValue(filename);
    } else {
      setFileValue(null);
      fileRef.current.value = null;
      //   handleClearClick();
    }
  }, [filename]);

  return (
    <>
      <div
        className={`form-field custom-file-uploader ${isDisable ? "field-disabled" : ""
          }`}
      >
        <input
          ref={fileRef}
          id={name}
          name={name}
          filename={fileValue ? fileValue : null}
          type={type ? type : "file"}
          className={cssClass}
          placeholder={placeholder}
          onChange={handleInputChange}
          onBlur={onBlur}
          disabled={isDisable}
          accept={acceptedFiles}
        />
        <div className="file-name-clear-btn">
          <div className="custom-file-selector-design">
            <Image
              imagePath={AppIcons.uploadDocsIcon}
              altText="Please Upload File"
            ></Image>

            {fileValue ?
              <p>{fileValue}</p>
              : ""}

            {fileValue ? null : (
              <>
                <div className="brows-btn">
                  <Button
                    className="btn success-btn"
                    onClick={handleClearClick}
                  >
                    {buttonText ? buttonText : "Upload File"}
                  </Button>
                </div>
              </>
            )}
          </div>
          {isButtonVisible && (
            <>
              {/* TODO: add Clear and Download icons */}
              <div className="clear-buttons d-flex">
                {fileValue && (
                  <Button className="btn btn-secondary" onClick={handleClearClick}>
                    Clear
                  </Button>
                )}
                {fileValue && viewImage && (
                  <Button className="ml-2 btn btn-info text-light" onClick={handleViewImageClick}>
                    View Image
                  </Button>
                )}

                {isDownloadButton && fileValue && (
                  <Button
                    className="ml-2 btn btn-success text-light"
                    onClick={handleActionClick}
                  >
                    Download
                  </Button>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

// FileUpload.propTypes = {
//   type: TextInputType.FILE.isRequired,
//   name: PropTypes.string,
//   placeholder: PropTypes.string,
//   // value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
//   onChange: PropTypes.func.isRequired,
//   onBlur: PropTypes.func,
//   onClear: PropTypes.func,
//   cssClass: PropTypes.string,
//   isDisable: PropTypes.bool,
// };
FileUpload.propTypes = {
  type: PropTypes.string, // Corrected PropTypes to string
  name: PropTypes.string,
  placeholder: PropTypes.string,
  filename: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onClear: PropTypes.func,
  onActionClick: PropTypes.func,
  cssClass: PropTypes.string,
  isDisable: PropTypes.bool,
  isButtonVisible: PropTypes.bool,
  isDownloadButton: PropTypes.bool,
  acceptedFiles: PropTypes.string,
};
export default FileUpload;
